import { render, staticRenderFns } from "./heatmap3d.vue?vue&type=template&id=3b2b3df5&"
import script from "./heatmap3d.vue?vue&type=script&lang=js&"
export * from "./heatmap3d.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports